<template>
  <div>
    <div class="single-container">
      <img class="single-image" :src="itemChild.bookLogoUrl" alt="" />
      <div class="single-description">
        <div class="single-top">
          <span class="single-title">{{ itemChild.bookName }}</span>
          
        </div>
        <span class="single-brief">{{ itemChild.bookSummary }}</span>
        <div class="single-bottom">
          <span class="sort" v-if="itemChild.category">{{
            itemChild.category.split(",")[0]
          }}</span>
          <span class="single-title-right"
            >{{ itemChild.studyingVolume }}万热度</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "list-item-four",
  props: {
    itemChild: {
      type: Object,
      default: {
        studyingVolume:'',
        bookLogoUrl:'',
        category:''
      },
    },
  },
  data() {
    return {};
  },
  watch: {
    // current(val) {
    // 	if (val !== this.currentIndex) {
    // 		this.currentIndex = val;
    // 	}
    // }
  },
  methods: {},
  created() {},
};
</script>

<style scoped>
.single-container {
  display: flex;
  margin-top: 16px;
  justify-content: space-between;
}
.single-image {
  width: 96px;
  height: 128px;
  border-radius: 6px;
}
.single-description {
  /* margin-left: 16px; */
  width: 216px;
}
.single-top {
  margin-bottom: 8px;
  display: flex;
  /* justify-content: space-between; */
}
.single-title {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
    overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 18px;
  /* width: 72%; */
      max-width: 72%;
}
.single-brief {
  font-size: 14px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  color: #666666;
  line-height: 20px;
}
.single-author {
  font-size: 12px;
  color: #aaaaaa;
  width: 50%;
}

.single-title-right {
  font-size: 12px;
  color: #de3b34;
  line-height: 20px;
}
.sort {
  background-color: rgb(253, 245, 233);
  border-radius: 2px;
  font-size: 12px;
  padding: 0px 5px;
  color: #f09b28;
  margin-right: 8px;
  line-height: 20px;
}
.single-bottom {
  display: flex;
  /* justify-content: space-between; */
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/components/list-item-four.vue